import LoaderSvg from "../../assets/icons/spinner.svg?react";
import "./Loader.css";
export const Loader = ({ isLoading = false, isPage = false }) => {
  return (
    <>
      {isLoading && (
        <div className={isPage ? "loader-new loader-page" : "loader-new"}>
          <LoaderSvg />
        </div>
      )}
    </>
  );
};
